import { createStore, applyMiddleware, compose } from 'redux';

import reducer from 'reducers/app';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Configure middleware used by redux
const middlewares = [
];

// Environment specific middlewares configuration - using 'process.env.NODE_ENV' per parcel requirements
if (process.env.NODE_ENV === 'development') { // eslint-disable-line no-undef
  //const { logger } = require('redux-logger');
  //middlewares.push(logger);
}

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(...middlewares)),
);

export default store;
